import { action } from 'mobx';
import { FormStore, FormValidator } from '@estee/elc-form';
import { FIELD_TYPE } from '../../../constants/Constants';

export interface ISalonFormStoreAttributes {
  [FIELD_TYPE.STYLIST_NAME]: string;
}

class SalonFormStore extends FormStore<ISalonFormStoreAttributes> {
  constructor() {
    super({
      formValidator: new FormValidator(),
      initialValues: {
        [FIELD_TYPE.STYLIST_NAME]: '',
      },
    });
  }

  @action
  public updateStylistName = (
    stylistName: string,
  ): void => {
    this.setValues({
      ...this.values,
      [FIELD_TYPE.STYLIST_NAME]: stylistName || '',
    });
  };
}

export default SalonFormStore;
